import { Grid, Link, List, ListItemText, Typography } from '@material-ui/core';
import React from 'react';
import Project from '../components/Project';

const MMAFederation = () => {
    const list = [
        `Responsible for game and server maintenance;`,
        `Added new gyms, teams, fighters and IAP’s cosmetic items;`,
        `Implemented ad networks integrations, rewarded videos and Game Analytics;`,
        `Server maintenance in Node.js, creating new tournaments with prizes using Redis and MongoDB databases;`,
    ];

    return (
        <Project>
            <Grid item xs={12}>
                <div className='aspect-ratio'>
                    <iframe
                        width='1904'
                        height='778'
                        src='https://www.youtube.com/embed/u7MN5Q_A8zE'
                        title='MMA Federation Trailer'
                        frameBorder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                    ></iframe>
                </div>
            </Grid>
            <Grid item xs={12}>
                <Typography variant='h1' component='h1' gutterBottom>
                    MMA Federation
                </Typography>
                <Typography variant='overline' display='block'>
                    Turn-Based Deck Building Card MMA Fighting game
                </Typography>
                <br />
                <Typography gutterBottom>
                    My team was responsible for the game's maintenance and
                    adding new features to the finished game.
                </Typography>
                <br />
                <Typography gutterBottom>Some of my tasks included:</Typography>
                <List>
                    {list.map((t, i) => (
                        <ListItemText key={`task-${i}`}>
                            &bull; {t}
                        </ListItemText>
                    ))}
                </List>
                <br />
                <Typography>
                    Developed at{' '}
                    <Link href='https://www.gazeus.com/en/'>Gazeus Games</Link>.
                </Typography>
            </Grid>
        </Project>
    );
};

export default MMAFederation;
